import { TTakeRate } from '~services/Representative';

const formatTakeRate = ({ type, amount }: TTakeRate): string =>
  type === 'FIXED'
    ? amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : `${amount.toLocaleString('pt-BR', { maximumFractionDigits: 2 })}%`;

export default formatTakeRate;
